import React, { useEffect, useRef, useState } from "react";
import styles from "./ProductFrom.module.css";
import PropTypes from "prop-types";
import { FastField, Field, Form, Formik } from "formik";
import InputFiled from "shared/components/InputField";
import Button from "@material-ui/core/Button";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { fetchListCategoryRequest } from "redux/ActionCreators/CategoryActionCreators";
import SelectFiled from "shared/components/SelectField/index";
import { fetchCreateProductRequest } from "redux/ActionCreators/ProductActionCreators";
import { ERROR_MESSAGE } from "shared/Constants";
import RichTextEditor from "react-rte";

function ProductFrom(props) {
  const [editorValue, setEditorValue] = useState(
    RichTextEditor.createValueFromString("", "html")
  );

  const handleChange = (value) => {
    setEditorValue(value);
  };

  const categories = useSelector((state) => {
    return state.categories.list.map((item) => {
      return {
        value: item.id,
        name: item.name,
      };
    });
  });

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchListCategoryRequest());
  }, []);

  const handleSubmit = (data) => {
    data = {
      name: data.name,
      rating: data.rating,
      price: data.price,
      priceDiscount: data.priceDiscount,
      description: editorValue.toString("html"),
      category: { id: data.category },
      imageRegex: `${data.image1} ${data.image2} ${data.image3} ${data.image4}`,
      weight: data.weight,
      numberProductsRemaining: data.numberProductsRemaining,
      numberProductSold: data.numberProductSold,
    };

    // console.log(data);
    dispatch(fetchCreateProductRequest(data));
  };

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => {
          return (
            <Form className={styles.content}>
              <div className={styles.item}>
                <FastField
                  name="name"
                  component={InputFiled}
                  label="Tên sản phẩm"
                />
              </div>
              <div className={styles.item}>
                <Field
                  name="category"
                  component={SelectFiled}
                  label="Thể loại"
                  options={categories}
                />
              </div>
              <div className={styles.item}>
                <FastField
                  name="rating"
                  component={InputFiled}
                  type="number"
                  label="Rating"
                />
              </div>
              <div className={styles.item}>
                <FastField
                  name="price"
                  component={InputFiled}
                  type="number"
                  label="Giá"
                />
              </div>
              <div className={styles.item}>
                <FastField
                  name="priceDiscount"
                  component={InputFiled}
                  label="Giá giảm"
                  type="number"
                />
              </div>
              <div className={styles.item}>
                <FastField
                  name="weight"
                  component={InputFiled}
                  label="Cân nặng"
                  type="number"
                />
              </div>
              <div className={styles.item}>
                <FastField
                  name="numberProductsRemaining"
                  component={InputFiled}
                  label="Sản phẩm còn"
                  type="number"
                />
              </div>
              <div className={styles.item}>
                <FastField
                  name="numberProductSold"
                  component={InputFiled}
                  label="Sản phẩm đã bán"
                  type="number"
                />
              </div>
              <div className={styles.item}>
                <FastField
                  name="image1"
                  component={InputFiled}
                  label="image1"
                />
              </div>
              <div className={styles.item}>
                <FastField
                  name="image2"
                  component={InputFiled}
                  label="image2"
                />
              </div>
              <div className={styles.item}>
                <FastField
                  name="image3"
                  component={InputFiled}
                  label="image3"
                />
              </div>
              <div className={styles.item}>
                <FastField
                  name="image4"
                  component={InputFiled}
                  label="image4"
                />
              </div>

              <div className={styles.item}>
                <RichTextEditor
                  value={editorValue}
                  onChange={handleChange}
                  required
                  id="body-text"
                  name="bodyText"
                  type="string"
                  multiline
                  variant="filled"
                  style={{ minHeight: 410 }}
                />
              </div>
              <Button
                variant="contained"
                color="secondary"
                size="large"
                type="submit"
                className={styles.btn_submit}
              >
                Lưu Lai
              </Button>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}

ProductFrom.propTypes = {};

const initialValues = {
  name: "",
  rating: 0,
  price: 0,
  priceDiscount: 0,
  weight: 0,
  numberProductsRemaining: 0,
  numberProductSold: 0,
  image1: "",
  image2: "",
  image3: "",
  image4: "",
  category: 8,
};

const validationSchema = Yup.object().shape({
  name: Yup.string().required(ERROR_MESSAGE.TEXT_FIELD_REQUIRED),
  rating: Yup.number()
    .required(ERROR_MESSAGE.TEXT_FIELD_REQUIRED)
    .min(1, "Rating phải lớn hơn 1")
    .max(5, "Rating phải nhỏ hơn 5"),
  price: Yup.number().required(ERROR_MESSAGE.TEXT_FIELD_REQUIRED),
  priceDiscount: Yup.number(),
  weight: Yup.number().required(ERROR_MESSAGE.TEXT_FIELD_REQUIRED),
  numberProductsRemaining: Yup.number()
    .required(ERROR_MESSAGE.TEXT_FIELD_REQUIRED)
    .min(1),
  image1: Yup.string().required(ERROR_MESSAGE.TEXT_FIELD_REQUIRED),
  image2: Yup.string().required(ERROR_MESSAGE.TEXT_FIELD_REQUIRED),
  image3: Yup.string().required(ERROR_MESSAGE.TEXT_FIELD_REQUIRED),
  image4: Yup.string(),
  category: Yup.number().required(ERROR_MESSAGE.TEXT_FIELD_REQUIRED),
});
export default ProductFrom;
